module.exports = __webpack_public_path__ + "static/media/refrimuro.6d168efa.pdf";